import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { X, Send, Sparkles, Check } from './Icons.jsx';
import { useAuth } from '../lib/auth.jsx';

export default function FeedbackWidget() {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState('');
  const [type, setType] = useState('bug');
  const [state, setState] = useState({ status: 'idle', message: '' });
  const loc = useLocation();
  const { user } = useAuth();

  const submit = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    setState({ status: 'sending', message: '' });
    try {
      const res = await fetch('/api/feedback', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          type,
          message: text.trim(),
          path: loc.pathname,
          email: user?.email || null,
          ua: navigator.userAgent
        })
      });
      if (!res.ok) throw new Error('Failed');
      setState({ status: 'sent', message: 'Thanks — we read every one.' });
      setText('');
      setTimeout(() => { setOpen(false); setState({ status: 'idle', message: '' }); }, 1800);
    } catch {
      setState({ status: 'error', message: 'Could not send. Try again in a moment.' });
    }
  };

  if (loc.pathname.startsWith('/drill') || loc.pathname.startsWith('/tutor-portal') || loc.pathname === '/parents' || loc.pathname === '/teachers') return null;

  if (!open) {
    return (
      <button onClick={() => setOpen(true)} style={fab} aria-label="Send feedback">
        <Sparkles width="16" height="16" />
      </button>
    );
  }

  return (
    <div style={panel}>
      <div style={head}>
        <strong style={{ fontSize: 15 }}>Send feedback</strong>
        <button onClick={() => setOpen(false)} aria-label="Close" style={{ background: 'none', border: 'none', color: 'var(--text-muted)', cursor: 'pointer', padding: 4 }}><X width="14" height="14" /></button>
      </div>

      {state.status === 'sent' ? (
        <div style={{ padding: 20, textAlign: 'center', color: 'var(--live-green)', fontWeight: 600 }}>
          <Check width="22" height="22" style={{ display: 'block', margin: '0 auto 8px' }} />
          {state.message}
        </div>
      ) : (
        <form onSubmit={submit} style={{ padding: 14 }}>
          <div style={{ display: 'flex', gap: 6, marginBottom: 10 }}>
            {[
              { id: 'bug', label: '🐛 Bug' },
              { id: 'idea', label: '💡 Idea' },
              { id: 'other', label: '🤔 Other' }
            ].map((t) => (
              <button key={t.id} type="button" onClick={() => setType(t.id)} style={pill(type === t.id)}>{t.label}</button>
            ))}
          </div>
          <textarea
            value={text} onChange={(e) => setText(e.target.value)} rows={4}
            placeholder={type === 'bug' ? 'What broke? Where? What did you expect?' : type === 'idea' ? 'What would make Medi better?' : 'Tell us anything…'}
            style={{ width: '100%', padding: '10px 12px', fontSize: 13.5, border: '1px solid var(--border-strong)', borderRadius: 8, fontFamily: 'inherit', resize: 'vertical' }}
          />
          {state.status === 'error' && <div style={{ color: '#b91c1c', fontSize: 12.5, marginTop: 6 }}>{state.message}</div>}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 10 }}>
            <span style={{ fontSize: 11.5, color: 'var(--text-muted)' }}>From: {loc.pathname}</span>
            <button type="submit" disabled={!text.trim() || state.status === 'sending'} className="btn btn-primary" style={{ fontSize: 13, padding: '6px 12px', opacity: text.trim() && state.status !== 'sending' ? 1 : 0.5 }}>
              {state.status === 'sending' ? 'Sending…' : 'Send'} <Send width="12" height="12" />
            </button>
          </div>
        </form>
      )}
    </div>
  );
}

const fab = {
  position: 'fixed', bottom: 88, right: 18, zIndex: 50,
  width: 36, height: 36, borderRadius: '50%',
  background: 'linear-gradient(135deg, var(--brand-deep), var(--brand-purple))',
  border: 'none', color: '#fff', cursor: 'pointer',
  display: 'grid', placeItems: 'center',
  boxShadow: '0 8px 22px rgba(35, 20, 63, 0.32)',
  opacity: 0.78
};
const panel = {
  position: 'fixed', bottom: 88, right: 18, zIndex: 50,
  width: 'min(320px, calc(100vw - 36px))',
  background: '#fff', borderRadius: 14,
  boxShadow: '0 20px 50px rgba(35, 20, 63, 0.35)',
  border: '1px solid var(--border)',
  animation: 'mm-slide-up 280ms ease'
};
const head = { padding: '12px 14px', borderBottom: '1px solid var(--border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' };
const pill = (active) => ({
  padding: '6px 10px', borderRadius: 99, fontSize: 12, fontWeight: 600,
  border: `1px solid ${active ? 'var(--brand-purple)' : 'var(--border)'}`,
  background: active ? 'var(--accent-soft)' : '#fff',
  color: active ? 'var(--brand-deep)' : 'var(--text-2)',
  cursor: 'pointer', fontFamily: 'inherit'
});
